import type { FaireProductEntity } from "../../entity_types/product";

export const p_satfrc8862: FaireProductEntity = {
  token: "p_satfrc8862",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - GREY",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/d12290dd5a8833905a91e0a68df0da1f9d116a89b3e28c57d28a6e1649013f02.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "Bubble Skirt by Girlie Girl Originals in Grey. A women’s skirt designed with a bubble silhouette for a rounded shape and added fullness. Styled for casual or dressier wear, it pairs with fitted tops or layers. From Girlie Girl Originals, a brand offering bold, fun apparel with southern flair for boutiques and retailers.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:31.706Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
